import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Input from "../../../Components/Utils/Input";

import { Form, Formik } from "formik";
import * as Yup from "yup";
// import BasicInput from "../../../Components/Utils/BasicInput";
// import Input from "../../../Components/Utils/Input";
import { ThreeDots } from "react-loader-spinner";
import messageSlice from "../../Redux/MessageSlice";
import BaseApi from "../../Http/BaseApi";
import { getAcademicSessionsAsync } from "../../Redux/MasterSlice";
import PageTitle from "../../Components/Common/PageTitle";
import Alert from "../../Components/Utils/Alert";
import CustomSelect from "../../Components/Utils/CustomSelect";
import Button from "../../Components/Utils/Button";
import { useNavigate } from "react-router-dom";
// import Input from "../../Components/Utils/Input";
// import Button from "../../Components/Utils/Button";
// import BasicInput from "../../../Components/Utils/BasicInput";
// import moment from "moment";
import tableToCSV from "../../Components/Utils/TableToCSV";

export default function BudgetSummary() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const formikRef = useRef();
  const [initialValues, setInitialValues] = useState();
  const [loading, setLoading] = useState(false);
  const [proposals, setProposals] = useState([]);
  const master = useSelector((state) => state.master);
  const academicSessions = [...master.academicSessions];
  const { message } = useSelector((state) => state.message);
  const [openBudgets, setOpenBudgets] = useState([]);

  // const [formRole, setFormRole] = useState("add");

  //   const dispatch = useDispatch();
  useEffect(() => {
    dispatch(messageSlice.actions.clearMessage());
    // if (!can("View Attendance Sheet")) {
    //   navigate(`/not-found`);
    // }

    // dispatch(messageSlice.actions.clearMessage());
    if (academicSessions.length === 0) {
      dispatch(getAcademicSessionsAsync());
    }
    getOpenBudgets();
    setInitialValues({
      academic_session_id: "",
      acc_budget_form_id: "",
    });

    // dispatch(getOldStudentsAsync());
  }, [dispatch]);
  console.log(initialValues);
  let currentSession = academicSessions.find((e) => {
    return e.id == formikRef.current?.values?.academic_session_id;
  });

  let lastSession = academicSessions.find((as) => {
    return as.serial == currentSession?.serial - 1;
  });

  let last2Session = academicSessions.find((as) => {
    return as.serial == currentSession?.serial - 2;
  });

  const validationSchema = Yup.object().shape({
    academic_session_id: Yup.string().required("This field is required!"),
  });

  const getOpenBudgets = async () => {
    await BaseApi()
      .get(`get-open-budgets?from_admin=1`)
      .then((response) => {
        const sortedData = response.data.sort((a, b) => {
          // Assuming academic_session_id is a numeric value
          return b.academic_session_id - a.academic_session_id;
        });

        setOpenBudgets(sortedData);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleSubmit = async (payload) => {
    dispatch(messageSlice.actions.clearMessage());
    console.log(payload);
    setLoading(true);
    await BaseApi().post(`budget-proposal-submit`, payload);

    setLoading(false);
    // resetForm({ academic_session_id: "", details: [] });

    // setInitialValues({
    //   academic_session_id: "",
    //   type: type,
    //   details: [],
    // });
    dispatch(messageSlice.actions.setMessage("Budget Submitted Successfully"));
  };

  const callProposals = async (selectedOption) => {
    setLoading(true);
    const _proposals = await BaseApi().get(`budget-proposals`, {
      params: {
        acc_budget_form_id: selectedOption.id,
        cost_center_id: "all",
      },
    });

    setProposals(_proposals.data);

    setInitialValues({
      acc_budget_form_id: selectedOption.id,
      academic_session_id: selectedOption.academic_session_id,
    });
    setLoading(false);
  };

  return (
    <>
      <div className='py-2'>
        <div className='container min-h-screen mx-auto bg-white rounded shadow dark:bg-gray-800'>
          <div className='w-full px-5 '>
            <PageTitle name='Budget Summary' />
            {message && <Alert message={message} />}
            <Formik
              innerRef={formikRef}
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Form>
                <div className='grid gap-8 py-5 pt-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3'>
                  <CustomSelect
                    options={academicSessions}
                    name='academic_session_id'
                    label='Select Financial Year'
                    isSearchable={true}
                    getOptionValue={(option) => `${option}`}
                    getOptionLabel={(option) => `  ${option.label}  `}
                    onChange={(selectedOption) => {
                      formikRef.current?.setFieldValue(
                        "academic_session_id",
                        selectedOption.id
                      );
                      formikRef.current?.setFieldValue(
                        "acc_budget_form_id",
                        ""
                      );
                      setInitialValues({
                        academic_session_id: selectedOption.id,
                        acc_budget_form_id: "",
                      });
                      // console.log(selectedOption.id);
                    }}
                  />
                  {initialValues?.academic_session_id > 0 && (
                    <CustomSelect
                      key={initialValues?.academic_session_id}
                      options={openBudgets.filter(
                        (ob) =>
                          ob.academic_session_id ==
                          initialValues?.academic_session_id
                      )}
                      name='acc_budget_form_id'
                      label='Select Budget Master'
                      isSearchable={true}
                      getOptionValue={(option) => `${option}`}
                      getOptionLabel={(option) =>
                        `${option.budget_master?.name} - ${option.academic_session?.label}  `
                      }
                      onChange={(selectedOption) => {
                        console.log(selectedOption);
                        formikRef.current?.setFieldValue(
                          "acc_budget_form_id",
                          selectedOption.id
                        );

                        formikRef.current?.setFieldValue(
                          "academic_session_id",
                          selectedOption.academic_session_id
                        );

                        callProposals(selectedOption);
                      }}
                    />
                  )}
                </div>
                {loading == true && (
                  <>
                    <div className='flex'>
                      <span className='m-auto'>
                        <ThreeDots
                          height='100'
                          width='100'
                          color='grey'
                          ariaLabel='loading'
                        />
                      </span>
                    </div>
                  </>
                )}
                <Button
                  type='button'
                  classNames='float-right bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'
                  value={"Download CSV"}
                  onClick={() => tableToCSV("datatable")}
                  icon={"DownloadIcon"}
                />

                {proposals?.length > 0 && (
                  <>
                    <table
                      id='datatable'
                      className='min-w-full mt-5 bg-white dark:bg-gray-800'
                    >
                      <thead>
                        <tr className='h-24 border-b border-gray-300 dark:border-gray-200'>
                          <th className='table-head'>Particulars</th>
                          <th className='table-head'>
                            {" "}
                            Actual
                            {
                              academicSessions.find((as) => {
                                return as.serial == currentSession?.serial - 2;
                              })?.label
                            }
                          </th>
                          <th className='table-head'>
                            {" "}
                            Budget
                            {
                              academicSessions.find((as) => {
                                return as.serial == currentSession?.serial - 1;
                              })?.label
                            }
                          </th>
                          <th className='table-head'>
                            {" "}
                            Revised
                            {
                              academicSessions.find((as) => {
                                return as.serial == currentSession?.serial - 1;
                              })?.label
                            }
                          </th>
                          <th className='table-head'>
                            {" "}
                            Budget {currentSession?.label}
                          </th>
                          <th className='table-head'>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className='h-24 border-b border-gray-300 dark:border-gray-200'>
                          <td className='table-data'>Total Receipt</td>
                          <td className='table-data'>
                            {" "}
                            {proposals
                              .filter(
                                (p) =>
                                  p.academic_session_id == last2Session.id &&
                                  p.budget_type == 2
                              )
                              ?.reduce(
                                (partialSum, proposal) =>
                                  partialSum +
                                  (parseInt(proposal.proposed_amount_receipt) ||
                                    0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td className='table-data'>
                            {" "}
                            {proposals
                              .filter(
                                (p) =>
                                  p.academic_session_id == lastSession.id &&
                                  p.budget_type == 0
                              )
                              ?.reduce(
                                (partialSum, proposal) =>
                                  partialSum +
                                  (parseInt(proposal.proposed_amount_receipt) ||
                                    0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td className='table-data'>
                            {" "}
                            {proposals
                              .filter(
                                (p) =>
                                  p.academic_session_id == lastSession.id &&
                                  p.budget_type == 1
                              )
                              ?.reduce(
                                (partialSum, proposal) =>
                                  partialSum +
                                  (parseInt(proposal.proposed_amount_receipt) ||
                                    0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td className='table-data'>
                            {" "}
                            {proposals
                              .filter(
                                (p) =>
                                  p.academic_session_id == currentSession.id &&
                                  p.budget_type == 0
                              )
                              ?.reduce(
                                (partialSum, proposal) =>
                                  partialSum +
                                  (parseInt(proposal.proposed_amount_receipt) ||
                                    0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td className='table-data'>
                            {" "}
                            <Button
                              classNames='bg-gradient-to-r from-pink-500 to-yellow-500 hover:bg-blue-700 focus:ring-blue-500'
                              value={"Details"}
                              icon={"ChevronDoubleRightIcon"}
                              onClick={() => {
                                navigate(
                                  `/budget-proposals/receipt/${formikRef.current.values?.acc_budget_form_id}`
                                );
                              }}
                            />
                          </td>
                        </tr>
                        <tr className='h-24 border-b border-gray-300 dark:border-gray-200'>
                          <td className='table-data'>Total Payment</td>
                          <td className='table-data'>
                            {proposals
                              .filter(
                                (p) =>
                                  p.academic_session_id == last2Session.id &&
                                  p.budget_type == 2
                              )
                              ?.reduce(
                                (partialSum, proposal) =>
                                  partialSum +
                                  (parseInt(proposal.proposed_amount_payment) ||
                                    0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td className='table-data'>
                            {" "}
                            {proposals
                              .filter(
                                (p) =>
                                  p.academic_session_id == lastSession.id &&
                                  p.budget_type == 0
                              )
                              ?.reduce(
                                (partialSum, proposal) =>
                                  partialSum +
                                  (parseInt(proposal.proposed_amount_payment) ||
                                    0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td className='table-data'>
                            {proposals
                              .filter(
                                (p) =>
                                  p.academic_session_id == lastSession.id &&
                                  p.budget_type == 1
                              )
                              ?.reduce(
                                (partialSum, proposal) =>
                                  partialSum +
                                  (parseInt(proposal.proposed_amount_payment) ||
                                    0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td className='table-data'>
                            {" "}
                            {proposals
                              .filter(
                                (p) =>
                                  p.academic_session_id == currentSession.id &&
                                  p.budget_type == 0
                              )
                              ?.reduce(
                                (partialSum, proposal) =>
                                  partialSum +
                                  (parseInt(proposal.proposed_amount_payment) ||
                                    0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td className='table-data'>
                            {" "}
                            <Button
                              classNames='bg-gradient-to-r from-pink-500 to-yellow-500 hover:bg-blue-700 focus:ring-blue-500'
                              value={"Details"}
                              icon={"ChevronDoubleRightIcon"}
                              onClick={() => {
                                navigate(
                                  `/budget-proposals/payment/${formikRef.current.values?.acc_budget_form_id}`
                                );
                              }}
                            />
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr className='h-24 border-b border-gray-300 dark:border-gray-200'>
                          <th className='table-head'> Surplus/Deficit</th>
                          <th className='table-head'>
                            {(
                              proposals
                                .filter(
                                  (p) =>
                                    p.academic_session_id == last2Session.id &&
                                    p.budget_type == 2
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal.proposed_amount_receipt
                                    ) || 0),
                                  0
                                ) -
                              proposals
                                .filter(
                                  (p) =>
                                    p.academic_session_id == last2Session.id &&
                                    p.budget_type == 2
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal.proposed_amount_payment
                                    ) || 0),
                                  0
                                )
                            ).toFixed(2)}
                          </th>
                          <th className='table-head'>
                            {" "}
                            {(
                              proposals
                                .filter(
                                  (p) =>
                                    p.academic_session_id == lastSession.id &&
                                    p.budget_type == 0
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal.proposed_amount_receipt
                                    ) || 0),
                                  0
                                ) -
                              proposals
                                .filter(
                                  (p) =>
                                    p.academic_session_id == lastSession.id &&
                                    p.budget_type == 0
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal.proposed_amount_payment
                                    ) || 0),
                                  0
                                )
                            ).toFixed(2)}
                          </th>
                          <th className='table-head'>
                            {(
                              proposals
                                .filter(
                                  (p) =>
                                    p.academic_session_id == lastSession.id &&
                                    p.budget_type == 1
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal.proposed_amount_receipt
                                    ) || 0),
                                  0
                                ) -
                              proposals
                                .filter(
                                  (p) =>
                                    p.academic_session_id == lastSession.id &&
                                    p.budget_type == 1
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal.proposed_amount_payment
                                    ) || 0),
                                  0
                                )
                            ).toFixed(2)}
                          </th>
                          <th className='table-head'>
                            {" "}
                            {(
                              proposals
                                .filter(
                                  (p) =>
                                    p.academic_session_id ==
                                      currentSession.id && p.budget_type == 0
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal.proposed_amount_receipt
                                    ) || 0),
                                  0
                                ) -
                              proposals
                                .filter(
                                  (p) =>
                                    p.academic_session_id ==
                                      currentSession.id && p.budget_type == 0
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal.proposed_amount_payment
                                    ) || 0),
                                  0
                                )
                            ).toFixed(2)}
                          </th>
                          <th className='table-head'></th>
                        </tr>
                      </tfoot>
                    </table>
                  </>
                )}
              </Form>
            </Formik>

            <br />
          </div>
        </div>
      </div>
    </>
  );
}
